// extracted by mini-css-extract-plugin
export default {"fileInput":"FileUpload_fileInput__-hukl","example":"FileUpload_example__veh5B","wrapper":"FileUpload_wrapper__1FSfm"};